import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'contractawards/matcheswithid',
    template: '<div></div>'
})
export class CaMatchesWithIdComponent implements OnInit {
    private readonly fromUrlKey = 'matchingContractAwardId';
    routeParamsSub: Subscription;

    constructor(private readonly router: Router, private readonly route: ActivatedRoute) {
        
    }

    ngOnInit() {
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            localStorage.setItem(this.fromUrlKey, params['id']);

            this.router.navigateByUrl('/contractawards/mymatches');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/matches.with.id.component.ts